import { Component, HostListener, OnInit, Injector  } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DashboardService } from 'src/app/services/dashboard/dashboard.service';
import * as XLSX from 'xlsx';
import { UsuarioService } from '../../services/usuario/usuario.service';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MonthYearFormatPipe } from '../../pipes/monthYearFormat.pipe';
import Swal from 'sweetalert2';
import { FundersService, ParametrosGeneralesService } from 'src/app/services/service.index';
// FUNDER DASHBOARD - START
import { FunderDashboardService } from 'src/app/services/service.index';
// FUNDER DASHBOARD - END

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  @HostListener('window:resize', ['$event'])
  onResize(event) {this.esmovil(event.target.innerWidth);}
  // animaciones y banderas para los elementos
  groupedData: { [key: string]: { data: any[], visible: boolean } } = {};
  groupedDataCad: { [key: string]: { data: any[], visible: boolean } } = {};
  currentMonth: string;
  animationClass = '';
  animationClassRo1 = '';
  animationClassRo3 = '';
  animationClassRo4 = '';
  animationClassRo5 = '';
  ro1 = false;
  ro2 = false;
  ro3 = false;
  ro4 = false;
  ro5 = false;
  /////
  mobile = false;
  // REVISAR_ELIMINAR: usuarios se declara pero nunca se usa en el template
  // usuarios: string;
  idu = '';
  // REVISAR_ELIMINAR: data y data3 se declaran pero nunca se asignan (los charts que los usan mostrarán vacío)
  // data: any;
  // data3: any;
  data2: any;
  options: any;
  optionsdi: any;
  // REVISAR_ELIMINAR: options2 se declara pero nunca se asigna
  // options2: any;
  // REVISAR_ELIMINAR: adminInvoices, adminRequests nunca se asignan en ngOnInit (siempre vacíos)
  // adminInvoices: any[] = [];
  // adminRequests: any[] = [];
  // REVISAR_ELIMINAR: nombrecadena, totalintereses, posemana nunca se asignan en ngOnInit
  // nombrecadena: string;
  // totalintereses = '0';
  // posemana = '0';
  // REVISAR_ELIMINAR: primerdash nunca se pone en true, la sección *ngIf="primerdash" del HTML nunca se muestra
  // primerdash = false;
  // SOFOM ////////
  sofomdash = false;
  afiliadostotales: any[] = [];
  dispuestointeres: any[] = [];
  // REVISAR_ELIMINAR: facturasvsdescue se declara pero solo se usa facturasvsdesord (que es el sorted)
  // facturasvsdescue: any[] = [];
  facturasvsdesord: any[] = [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}];
  // REVISAR_ELIMINAR: proveedoresafili se declara pero solo se usa proveedoresaford (que es el sorted)
  // proveedoresafili: any[] = [];
  proveedoresaford: any[] = [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}];
  avgdiscountdays : any[] = [];
  // REVISAR_ELIMINAR: pagosydisperciones se declara pero nunca se asigna ni se usa en el template
  // pagosydisperciones: any[] = [];
  ImpTotFacUlTresMeses: any[] = [];
  ImpTotFacNoDescXCad: any[] = []; 
  ImpTotOpxMesACur: any[] = [];
  ImpTotOxFonYRecuProp: any[] = [];
  TopTenProvXImpOpDivXMes: any[] = [];
  TopTenCadXImpOpDivXMes: any[] = [];
  IntOpMes: any[] = [];
  ImpTotCobCadXMes: any[] = [];
  // FOREIGN SUPPLIERS DASHBOARD - START
  // 29/07/2026 - Estado del listado de proveedores extranjeros (dashboard SOFOM).
  foreignSuppliers: any[] = [];
  currentPageFS: number = 1;
  itemsPerPageFS: number = 10;
  maxVisiblePagesFS: number = 8;
  sortColumnFS: string = '';
  sortDirectionFS: 'asc' | 'desc' = 'asc';
  searchTermsFS = {
    nombre_cadena: '',
    nombre_proveedor: '',
    fecha_alta: '',
    facturas_subidas: '',
    facturas_operadas: '',
    facturas_pagadas: ''
  };
  // FOREIGN SUPPLIERS DASHBOARD - END
  ////////////////
  // COMPANY /////
  companydash = false;
  // REVISAR_ELIMINAR: Las siguientes propiedades de COMPANY no se usan en el template ni se asignan en ngOnInit
  // facturasCanceladas: any[] = [];
  // proximosPagos: any[] = [];
  // facturasdescontadas: any[] = [];
  // facturasdescontadasproveedores: any[] = [];
  // facturascanceladastotales: any[] = [];
  // comisionPagoSofom: any[] = [];
  // porcentajecomision = '';
  // isCompany: any[] = [];
  credit_limit_company: any[] = [];
  showCreditLimitCompany = false;
  ///////////////
  // SUPLIER ////
  suplierdash = false;
  facturasnodescontadas: any[] = [];
  facturasdescontadassuplier: any[] = [];
  facturasdescontadasmes: any[] = [];
  importefacturas: any[] = [];
  // REVISAR_ELIMINAR: isSuppier no se usa en el template ni se asigna en ngOnInit
  // isSuppier: any[] = [];
  credit_limit_supplier: any[] = [];
  showCreditLimitSupplier = false;
  ///////////////
  //BANCOPPEL ///
  sortColumn: string = ''; // Columna actual de ordenación
  sortDirection: 'asc' | 'desc' = 'asc'; // Dirección de ordenación
  selectedIdsf: string | null = null;
  showmodalds: boolean;
  bancoppeldash = false;
  SolFonHisEssol: any[] = [];
  SolFonHisEsDifsol: any[] = [];
  ClienxCadena: any[] = [];
  // REVISAR_ELIMINAR: items se declara pero nunca se usa como fuente de datos en el template
  // items: any[] = [];
  datosdetalles: any[] = [];
  currentPage: number = 1;
  itemsPerPage: number = 10;
  // REVISAR_ELIMINAR: searchTerm (singular) se declara pero nunca se usa en el template, solo searchTerms (plural)
  // searchTerm: string = '';
  maxVisiblePages: number = 8; // Número máximo de páginas visibles
  searchTerms = {
    folio_solicitud_fondeo: '',
    cadena: '',
    fecha_solicitud: '',
    moneda: '',
    total: '',
    total_operado: '',
    intereses: '',
    monto_neto: ''
  };
  /////////////
  // FUNDER DASHBOARD - START
  fondeadordash = false;
  funderId: number;
  lineasCredito: any[] = [];
  facturasfondeador: any[] = [];
  // Paginación y búsqueda - Líneas de Crédito
  currentPageLC: number = 1;
  itemsPerPageLC: number = 10;
  maxVisiblePagesLC: number = 8;
  searchTermsLC = {
    company_name: '',
    company_rfc: '',
    credit_limit: '',
    credit_available: '',
    tiie_rate: ''
  };
  // Paginación y búsqueda - Facturas Fondeador
  currentPageFF: number = 1;
  itemsPerPageFF: number = 10;
  maxVisiblePagesFF: number = 8;
  searchTermsFF = {
    funding_request_folio: '',
    funding_request_status: '',
    invoice_folio: '',
    issuer_name: '',
    receiver_name: '',
    total_operated: '',
    total_interests: '',
    total_net: '',
    total_commission: '',
    operation_date: '',
    due_date: '',
    operation_days: '',
    tiie_rate: '',
    surcharge_rate: '',
    total_rate: ''
  };
  // FUNDER DASHBOARD - END
      //COMPANY REPORTE FACTURAS ///
    facturas: any[] = [];
    sortColumnCo: string = ''; // Columna actual de ordenación
    sortDirectionCo: 'asc' | 'desc' = 'asc'; // Dirección de ordenación
    // REVISAR_ELIMINAR: itemsCo no se usa en el template ni en métodos activos
    // itemsCo: any[] = [];
    currentPageCo: number = 1;
    itemsPerPageCo: number = 10;
    // REVISAR_ELIMINAR: searchTermCo (singular) no se usa en el template, solo searchTermsCo (plural)
    // searchTermCo: string = '';
    maxVisiblePagesCo: number = 10; // Número máximo de páginas visibles
    searchTermsCo = {
      id_factura: '',
      folio_factura: '',
      folio_solicitud: '',
      folio_solicitud_fondeo: '',
      uuid_factura_descontada: '',
      emisor: '',
      receptor: '',
      customer_credit_name:'',
      moneda: '',
      fecha_operacion: '',
      fecha_cobranza: '',
      fecha_vencimiento: '',
      fecha_emision: '',
      fecha_carga: '',
      estatus: '',
      total_factura: '',
      porcentaje_operado: '',
      monto_operado: '',
      disponible: '',
      intereses: '',
      tasa_interbancaria: '',
      sobretasa: '',
      tasa_total: '',
      comision: '',
      costo_financiero: '',
      dias_descuento: '',
      monto_neto: '',
      tasa_comision: '',
      dia_pago_cadena: '',
      monto_pago: '',
      dias_al_vencimiento: '',
      dias_para_vencimiento: ''
      };
      // REVISAR_ELIMINAR: selectedRows, allData, selectedIdsfCo — no se usan en el template ni en métodos activos
      // selectedRows = new Set<any>();
      // allData = [];
      // selectedIdsfCo: string | null = null;
      isExpanded: boolean = false; // Controla si la tabla está expandida o colapsada
      // REVISAR_ELIMINAR: originalFecha, originalFechaVencimiento — no se usan en el template ni en métodos activos
      // originalFecha: string = '';
      // originalFechaVencimiento: string = '';
      isEditing: boolean = false; // Estado para controlar si se está editando un campo (usado en filteredDataqCo)
      // REVISAR_ELIMINAR: currentEditingItem, isAdmin — no se usan en el template ni en métodos activos
      // currentEditingItem: any = null;
      // isAdmin: boolean = false;
      visibleColumns: string[] = ['folio_factura', 'folio_solicitud', 
        'fecha_emision','uuid_factura_descontada', 'moneda', 'fecha_cobranza', 'fecha_vencimiento'
      ]; // Columnas visibles en el modo colapsado
      /////////////
  soyfactea = false;
  deltab = true;
  totdispu = 0;
  totcob = 0;
  delinquency = false;
  delinquencyResume = [];
  delinquencyResumeOrigin = [];
  // REVISAR_ELIMINAR: delinquencyColsEN/ES, delinquencyCols, tituloES/EN, titulo — solo se usaban en changeLg() que ya está comentado y el select selLg no existe en el HTML
  // delinquencyColsEN = [
  //   {field: 'customer', name: 'Customer'},
  //   {field: '1-30', name: '1-30'},
  //   {field: '31-60', name: '31-60'},
  //   {field: '46-60', name: '46-60'},
  //   {field: '61-90', name: '61-90'},
  //   {field: '+90', name: '+90'},
  //   {field: 'oldest_inovice_age', name: 'Oldest Invoice Age'},
  //   {field: 'total', name: 'Total'}
  // ];
  // delinquencyColsES = [
  //   {field: 'customer', name: 'Cliente'},
  //   {field: '1-30', name: '1-30'},
  //   {field: '31-60', name: '31-60'},
  //   {field: '46-60', name: '46-60'},
  //   {field: '61-90', name: '61-90'},
  //   {field: '+90', name: '+90'},
  //   {field: 'oldest_inovice_age', name: 'Factura más antigua'},
  //   {field: 'total', name: 'Total'}
  // ];
  // delinquencyCols = this.delinquencyColsES;
  customers = [];
  // tituloES = 'Facturas con retraso';
  // tituloEN = 'Old Invoices';
  // titulo = this.tituloES;

  thipousuario: any[] = [];
  fileName = '';
  // REVISAR_ELIMINAR: iw no se usa en el template ni en métodos activos
  // iw = 1300;
  constructor(public _usuarioservice: UsuarioService,
              public _dashboardservice: DashboardService,
              // REVISAR_ELIMINAR: route (ActivatedRoute) se inyecta pero nunca se usa en el componente
              private route: ActivatedRoute,
              public router: Router,
              private usuarioService: UsuarioService,
              private fundersService: FundersService,
              private injector: Injector,
              private _paramsService: ParametrosGeneralesService,
            // FUNDER DASHBOARD - START
            private _funderDashboardService: FunderDashboardService
            // FUNDER DASHBOARD - END
            ) {}

  ngOnInit() {
    this.optionsdi = {
      responsive: false,
      maintainAspectRatio: false
    };
    this.esmovil(window.innerWidth);
    this.idu = localStorage.getItem('id');
    this.companydash = false;
    this.suplierdash = false;
    this.sofomdash = false;
    this.bancoppeldash = false;
    this.delinquency = false;
    this.delinquencyResume = [];
    this.delinquencyResumeOrigin = [];
    this.customers = [];
    this.soyfactea = false;
    this.usuarioService.getUsuario(this.idu).subscribe(resp => {
      if(resp[0].status == 'PENDIENTE AFILIACION'){
        this.router.navigate(['/afiliacionalt']);
      }
    })
    if (localStorage.getItem('quiensoy').toUpperCase() === 'FACTEA') {
      this.visibleColumns = [
      'id_factura','folio_factura', 'uuid_factura_descontada', 'emisor', 'receptor', 'estatus', 'fecha_vencimiento', 'monto_operado', 'dias_para_vencimiento'
    ];
      this.soyfactea = true;
    }

    this._dashboardservice.getUserType(this.idu).subscribe( resp => { this.thipousuario = resp;
      // DASBOARD COPPEL ///////////////////////////////////////////////esta separada totalmente////
      const job = localStorage.getItem('job') ? localStorage.getItem('job').replace(/"/g, '').trim() : null;
      if (job && job === 'COPPEL') {
        // Realiza la acción que necesitas y termina la ejecución de esta función
        const observable1 = this._dashboardservice.getSolFonHisEssol().pipe(catchError(error => { return of (error); }));
        const observable2 = this._dashboardservice.getSolFonHisEsDifsol().pipe(catchError(error => { return of (error); }));
        const observable3 = this._dashboardservice.getClientesxCadena().pipe(catchError(error => { return of (error); }));
        forkJoin([observable1, observable2, observable3])
        .subscribe(
          async ([SolFonHisEssol, SolFonHisEsDifsol, ClienxCadena]) => {
            if (SolFonHisEssol !== undefined && !SolFonHisEssol.error) {
              this.SolFonHisEssol = SolFonHisEssol;
              
            }
            if (SolFonHisEsDifsol !== undefined && !SolFonHisEsDifsol.error) {
             // this.SolFonHisEsDifsol = SolFonHisEsDifsol;
              this.SolFonHisEsDifsol = SolFonHisEsDifsol;
                
            }
            if (ClienxCadena !== undefined && !ClienxCadena.error) {
              this.ClienxCadena = ClienxCadena
            }
            const errors = [
              SolFonHisEssol, SolFonHisEsDifsol, ClienxCadena
            ].filter(result => result.error);
      
            if (errors.length > 0) {
              console.error('llamadas con error: ', errors);
            }
            this.bancoppeldash = true;
            Swal.close();
        });  
        return; // Detiene la ejecución para evitar que se evalúen los if
      }
         
      ////////////////////////////////////////////////////////////////////
      // DASHBOARD SOFOM /////////////////////////////////////////////////
      if (this.thipousuario[0].tipo_usuario == 'SOFOM') {
        
        const observable1 = this._dashboardservice.getImpTotFacUlTresMeses().pipe(catchError(error => { return of (error); }));
        const observable2 = this._dashboardservice.getImpTotFacNoDescXCad().pipe(catchError(error => { return of (error); }));
        const observable3 = this._dashboardservice.getImpTotOpxMesACur().pipe(catchError(error => { return of (error); }));
        const observable4 = this._dashboardservice.getImpTotOxFonYRecuProp().pipe(catchError(error => { return of (error); }));
        const observable5 = this._dashboardservice.getTopTenProvXImpOpDivXMes().pipe(catchError(error => { return of (error); }));
        const observable6 = this._dashboardservice.getTopTenCadXImpOpDivXMes().pipe(catchError(error => { return of (error); }));
        const observable7 = this._dashboardservice.getIntOpMes().pipe(catchError(error => { return of (error); }));
        const observable8 = this._dashboardservice.getImpTotCobCadXMes().pipe(catchError(error => { return of (error); }));
        const observable9 = this._dashboardservice.getAfiliadosTotales().pipe(catchError(error => { return of (error); }));
        const observable10= this._dashboardservice.getAvgDiscountDays().pipe(catchError(error => { return of (error); }));
        const observable11= this._dashboardservice.getFacturasvsDescuentos().pipe(catchError(error => { return of (error); }));
        const observable12= this._dashboardservice.getProveedoresAfiliados().pipe(catchError(error => { return of (error); }));
        const observable13= this._dashboardservice.delinquencyIndicatorAdmin().pipe(catchError(error => { return of (error); }));
        const observable14= this._dashboardservice.getDispuestoInterescobrado().pipe(catchError(error => { return of (error); }));
        // FOREIGN SUPPLIERS DASHBOARD - START
        // 29/07/2026 - Se agrega la carga de proveedores extranjeros al forkJoin del dashboard SOFOM.
        const observable15= this._dashboardservice.getForeignSuppliers().pipe(catchError(error => { return of (error); }));
        // FOREIGN SUPPLIERS DASHBOARD - END
        forkJoin([observable1, observable2, observable3, observable4, observable5, observable6, observable7, observable8, observable9,
                  observable10, observable11, observable12, observable13, observable14, observable15
        ])
        .subscribe(
          async ([ImpTotFacUlTresMeses, ImpTotFacNoDescXCad, ImpTotOpxMesACur, ImpTotOxFonYRecuProp, TopTenProvXImpOpDivXMes,
          TopTenCadXImpOpDivXMes, IntOpMes, ImpTotCobCadXMes, afiliadostotales, avgdiscountdays, facturasvsdescue, proveedoresafiliados,
          delinquencyIndicatorAdmin, DispuestoInterescobrado, foreignSuppliers]) => {

            if (ImpTotFacUlTresMeses !== undefined && !ImpTotFacUlTresMeses.error) {
              this.ImpTotFacUlTresMeses = ImpTotFacUlTresMeses;
            }
            if (ImpTotFacNoDescXCad !== undefined && !ImpTotFacNoDescXCad.error) {
              this.ImpTotFacNoDescXCad = ImpTotFacNoDescXCad;
            }
            if (ImpTotOpxMesACur !== undefined && !ImpTotOpxMesACur.error) {
              this.ImpTotOpxMesACur = ImpTotOpxMesACur;
            }

            if (ImpTotOxFonYRecuProp !== undefined && !ImpTotOxFonYRecuProp.error) {
              this.ImpTotOxFonYRecuProp = ImpTotOxFonYRecuProp;
            }
            if (TopTenProvXImpOpDivXMes !== undefined && !TopTenProvXImpOpDivXMes.error) {
              this.TopTenProvXImpOpDivXMes = TopTenProvXImpOpDivXMes;
              this.groupDataByMonth();
            }
            if (TopTenCadXImpOpDivXMes !== undefined && !TopTenCadXImpOpDivXMes.error) {
              this.TopTenCadXImpOpDivXMes = TopTenCadXImpOpDivXMes;
              this.groupDataByMonthCad();
            }
            if (IntOpMes !== undefined && !IntOpMes.error) {
              this.IntOpMes = IntOpMes;
            }
            if (ImpTotCobCadXMes !== undefined && !ImpTotCobCadXMes.error) {
              this.ImpTotCobCadXMes = ImpTotCobCadXMes;
            }
            if (afiliadostotales !== undefined && !afiliadostotales.error) {
              this.afiliadostotales = afiliadostotales;
            }
            if (avgdiscountdays !== undefined && !avgdiscountdays.error) {
              this.avgdiscountdays = avgdiscountdays;
            }
            if (facturasvsdescue !== undefined && !facturasvsdescue.error) {
              this.facturasvsdesord = facturasvsdescue.sort((a: { mes: string; }, b: { mes: string; }) => {
              return this.getMonthIndex(a.mes) - this.getMonthIndex(b.mes);
              });
            }
            if (proveedoresafiliados !== undefined && !proveedoresafiliados.error) {
              this.proveedoresaford = proveedoresafiliados.sort((a: { mes: string; }, b: { mes: string; }) => {
              return this.getMonthIndex(a.mes) - this.getMonthIndex(b.mes);
              });
            }
            if (delinquencyIndicatorAdmin !== undefined && !delinquencyIndicatorAdmin.error) {
              if(delinquencyIndicatorAdmin.length > 0){
                delinquencyIndicatorAdmin.forEach((f: { customer: any; }) => {
                  this.delinquencyResume.push(f);
                  let encontrado = this.customers.find(c => c == f.customer);
                  if(encontrado == undefined){
                    this.customers.push(f.customer);
                  }
                });
                this.delinquencyResumeOrigin = this.delinquencyResume;
                this.delinquency = true;
              }
            }
            if (DispuestoInterescobrado !== undefined && !DispuestoInterescobrado.error) {
              this.dispuestointeres = DispuestoInterescobrado;
              this.totdispu = parseFloat(this.dispuestointeres[0].total_dispuesto_enero.replace(/,/g, ''))+
              parseFloat(this.dispuestointeres[0].total_dispuesto_febrero.replace(/,/g, ''))+
              parseFloat(this.dispuestointeres[0].total_dispuesto_marzo.replace(/,/g, ''))+
              parseFloat(this.dispuestointeres[0].total_dispuesto_abril.replace(/,/g, ''))+
              parseFloat(this.dispuestointeres[0].total_dispuesto_mayo.replace(/,/g, ''))+
              parseFloat(this.dispuestointeres[0].total_dispuesto_junio.replace(/,/g, ''))+
              parseFloat(this.dispuestointeres[0].total_dispuesto_julio.replace(/,/g, ''))+
              parseFloat(this.dispuestointeres[0].total_dispuesto_agosto.replace(/,/g, ''))+
              parseFloat(this.dispuestointeres[0].total_dispuesto_septiembre.replace(/,/g, ''))+
              parseFloat(this.dispuestointeres[0].total_dispuesto_octubre.replace(/,/g, ''))+
              parseFloat(this.dispuestointeres[0].total_dispuesto_noviembre.replace(/,/g, ''))+
              parseFloat(this.dispuestointeres[0].total_dispuesto_diciembre.replace(/,/g, ''))
              this.totcob = parseFloat(this.dispuestointeres[0].total_intereses_enero.replace(/,/g, ''))+
              parseFloat(this.dispuestointeres[0].total_intereses_febrero.replace(/,/g, ''))+
              parseFloat(this.dispuestointeres[0].total_intereses_marzo.replace(/,/g, ''))+
              parseFloat(this.dispuestointeres[0].total_intereses_abril.replace(/,/g, ''))+
              parseFloat(this.dispuestointeres[0].total_intereses_mayo.replace(/,/g, ''))+
              parseFloat(this.dispuestointeres[0].total_intereses_junio.replace(/,/g, ''))+
              parseFloat(this.dispuestointeres[0].total_intereses_julio.replace(/,/g, ''))+
              parseFloat(this.dispuestointeres[0].total_intereses_agosto.replace(/,/g, ''))+
              parseFloat(this.dispuestointeres[0].total_intereses_septiembre.replace(/,/g, ''))+
              parseFloat(this.dispuestointeres[0].total_intereses_octubre.replace(/,/g, ''))+
              parseFloat(this.dispuestointeres[0].total_intereses_noviembre.replace(/,/g, ''))+
              parseFloat(this.dispuestointeres[0].total_intereses_diciembre.replace(/,/g, ''))
                                                                                 this.data2 = {
             labels: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio',
                      'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
             datasets: [
                       {
                           label: 'Total Dispuesto ',
                           backgroundColor: '#949dab',
                           borderColor: '#1E88E5',
                           data: [parseFloat(this.dispuestointeres[0].total_dispuesto_enero.replace(/,/g, '')),
                                  parseFloat(this.dispuestointeres[0].total_dispuesto_febrero.replace(/,/g, '')),
                                  parseFloat(this.dispuestointeres[0].total_dispuesto_marzo.replace(/,/g, '')),
                                  parseFloat(this.dispuestointeres[0].total_dispuesto_abril.replace(/,/g, '')),
                                  parseFloat(this.dispuestointeres[0].total_dispuesto_mayo.replace(/,/g, '')),
                                  parseFloat(this.dispuestointeres[0].total_dispuesto_junio.replace(/,/g, '')),
                                  parseFloat(this.dispuestointeres[0].total_dispuesto_julio.replace(/,/g, '')),
                                  parseFloat(this.dispuestointeres[0].total_dispuesto_agosto.replace(/,/g, '')),
                                  parseFloat(this.dispuestointeres[0].total_dispuesto_septiembre.replace(/,/g, '')),
                                  parseFloat(this.dispuestointeres[0].total_dispuesto_octubre.replace(/,/g, '')),
                                  parseFloat(this.dispuestointeres[0].total_dispuesto_noviembre.replace(/,/g, '')),
                                  parseFloat(this.dispuestointeres[0].total_dispuesto_diciembre.replace(/,/g, ''))
                                  ]
                       },
                       {
                        label: 'Total Cobrado ',
                        backgroundColor: '#434750',
                        borderColor: '#7CB342',
                        data: [parseFloat(this.dispuestointeres[0].total_intereses_enero.replace(/,/g, '')),
                               parseFloat(this.dispuestointeres[0].total_intereses_febrero.replace(/,/g, '')),
                               parseFloat(this.dispuestointeres[0].total_intereses_marzo.replace(/,/g, '')),
                               parseFloat(this.dispuestointeres[0].total_intereses_abril.replace(/,/g, '')),
                               parseFloat(this.dispuestointeres[0].total_intereses_mayo.replace(/,/g, '')),
                               parseFloat(this.dispuestointeres[0].total_intereses_junio.replace(/,/g, '')),
                               parseFloat(this.dispuestointeres[0].total_intereses_julio.replace(/,/g, '')),
                               parseFloat(this.dispuestointeres[0].total_intereses_agosto.replace(/,/g, '')),
                               parseFloat(this.dispuestointeres[0].total_intereses_septiembre.replace(/,/g, '')),
                               parseFloat(this.dispuestointeres[0].total_intereses_octubre.replace(/,/g, '')),
                               parseFloat(this.dispuestointeres[0].total_intereses_noviembre.replace(/,/g, '')),
                               parseFloat(this.dispuestointeres[0].total_intereses_diciembre.replace(/,/g, ''))
                               ]
                    },
                       ]
            };
            }
            
            // FOREIGN SUPPLIERS DASHBOARD - START
            // 29/07/2026 - Asignaci\u00f3n del resultado del reporte de proveedores extranjeros.
            if (foreignSuppliers !== undefined && !foreignSuppliers.error) {
              this.foreignSuppliers = Array.isArray(foreignSuppliers) ? foreignSuppliers : [];
            }
            // FOREIGN SUPPLIERS DASHBOARD - END
            const errors = [
              ImpTotFacUlTresMeses, ImpTotFacNoDescXCad, ImpTotOpxMesACur, ImpTotOxFonYRecuProp,
              TopTenProvXImpOpDivXMes, TopTenCadXImpOpDivXMes, IntOpMes, ImpTotCobCadXMes,
              afiliadostotales, avgdiscountdays, facturasvsdescue, proveedoresafiliados,
              delinquencyIndicatorAdmin, DispuestoInterescobrado, foreignSuppliers
            ].filter(result => result.error);
      
            if (errors.length > 0) {
              console.error('llamadas con error: ', errors);
            }
            this.sofomdash = true;
            Swal.close();
            setTimeout(() => {
              const ro1Element = document.getElementById('ro1');
              if (ro1Element) {
                ro1Element.classList.remove('hidden');
                ro1Element.classList.add('fadeInUp');
                
              } else {
                console.log('');
              }
            }, 1); 
        });                                                      
      }
      // DASHBOARD COMPANY ////////////////////////////////////////////////
    // tslint:disable-next-line: align
    if (this.thipousuario[0].tipo_usuario == 'COMPANY') {
      this.companydash = true;
        this._paramsService.getGeneralParam('CREDIT_LINE_STATUS_COMPANY').subscribe(resp => {
        if (resp['value'] === 'SI') {
        this.showCreditLimitCompany = true;  
        this._dashboardservice.getCompanyInfo(this.thipousuario[0].company_id).subscribe(resp => { 
        this.credit_limit_company.push(resp)})
        } else {
          this.showCreditLimitCompany = false;
        }
      })
        this._dashboardservice.getReporteFactXCompany(this.thipousuario[0].company_id).subscribe( resp => {
          this.facturas = resp;
        } )
      }
      ////////////////////////////////////////////////////////////////////
      // DASHBOARD SUPLIER ////////////////////////////////////////////////
    if (this.thipousuario[0].tipo_usuario == 'SUPPLER') {
      this.credit_limit_supplier = [];
      this.suplierdash = true;
      this._paramsService.getGeneralParam('CREDIT_LINE_STATUS_SUPPLIER').subscribe(resp => {
        if (resp['value'].toUpperCase() === 'SI') {
        this.showCreditLimitSupplier = true;  
        this._dashboardservice.getSupplierInfo(this.thipousuario[0].supplier_id).subscribe(resp => { 
        this.credit_limit_supplier.push(resp)})
        } else {
          this.showCreditLimitSupplier = false;
        }
      })

      this._dashboardservice.getFacturasNoDescontadas(this.thipousuario[0].supplier_id, this.idu).subscribe( resp13 => { this.facturasnodescontadas = resp13; } );
      this._dashboardservice.getFacturasDescontadas(this.thipousuario[0].supplier_id, this.idu).subscribe( resp14 => { this.facturasdescontadassuplier = resp14; } );
      this._dashboardservice.getFacturasDescontadasMes(this.thipousuario[0].supplier_id, this.idu).subscribe( resp15 => { this.facturasdescontadasmes = resp15; } );
      this._dashboardservice.getImporteFacturas(this.thipousuario[0].supplier_id, this.idu).subscribe( resp16 => { this.importefacturas = resp16; } );
    }
    ////////////////////////////////////////////////////////////////////
    // FUNDER DASHBOARD - START
    if (this.thipousuario[0].tipo_usuario == 'FUNDER') {
      this._funderDashboardService.getFunderByUser(this.idu).subscribe(
        resp => {
          this.funderId = resp.funder_id;
          const obs1 = this._funderDashboardService.getFunderCreditLines(this.funderId)
            .pipe(catchError(error => { console.error('Error cargando líneas de crédito fondeador:', error); return of([]); }));
          const obs2 = this._funderDashboardService.getFunderInvoices(this.funderId)
            .pipe(catchError(error => { console.error('Error cargando facturas fondeador:', error); return of([]); }));
          forkJoin([obs1, obs2]).subscribe(([creditLines, invoices]) => {
            this.lineasCredito = creditLines;
            this.facturasfondeador = invoices;
            this.fondeadordash = true;
            Swal.close();
          });
        },
        error => {
          console.error('Error obteniendo fondeador por usuario:', error);
          Swal.close();
        }
      );
    }
    // FUNDER DASHBOARD - END
    ////////////////////////////////////////////////////////////////////
    } );
  }
  //Para la tabla top ten proveedores
  groupDataByMonth() {
    const currentYear = new Date().getFullYear();
    const months = [
    `ENERO ${currentYear}`, `FEBRERO ${currentYear}`, `MARZO ${currentYear}`, `ABRIL ${currentYear}`,
    `MAYO ${currentYear}`, `JUNIO ${currentYear}`, `JULIO ${currentYear}`, `AGOSTO ${currentYear}`,
    `SEPTIEMBRE ${currentYear}`, `OCTUBRE ${currentYear}`, `NOVIEMBRE ${currentYear}`, `DICIEMBRE ${currentYear}`
  ];

    months.forEach(month => {
      const filteredData = this.TopTenProvXImpOpDivXMes.filter(item => item.mes === month);

      // convierto el total a numero y lo ordeno de mayor a menor
      filteredData.sort((a, b) => parseFloat(b.total) - parseFloat(a.total));

      this.groupedData[month] = {
        data: filteredData,
        visible: false
      };
    });
      // aqui sacamos la tabla del mes actual que se pondra a la derecha
    this.currentMonth = this.getCurrentMonth();
    if (this.currentMonth && this.groupedData[this.currentMonth]) {
      this.groupedData[this.currentMonth].visible = true;
    }
  }

  getCurrentMonth(): string {
    const currentDate = new Date();
    const monthNames = [
        "ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO",
        "JULIO", "AGOSTO", "SEPTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE"
    ];
    const month = monthNames[currentDate.getMonth()];
    const year = currentDate.getFullYear();
    return `${month} ${year}`;
}

  toggleVisibility(month: string) {
    this.groupedData[month].visible = !this.groupedData[month].visible;
  }

  getKeys(obj: { [key: string]: { data: any[], visible: boolean } }) {
    return Object.keys(obj);
  }

  getMonthIndex(month: string): number {
    const monthOrder = [
      'ENERO', 'FEBRERO', 'MARZO', 'ABRIL', 'MAYO', 'JUNIO',
      'JULIO', 'AGOSTO', 'SEPTIEMBRE', 'OCTUBRE', 'NOVIEMBRE', 'DICIEMBRE'
    ];
    return monthOrder.indexOf(month);
  }

  //Para la tabla top ten cadenas
  groupDataByMonthCad() {
    const currentYear = new Date().getFullYear();
    const months = [
    `ENERO ${currentYear}`, `FEBRERO ${currentYear}`, `MARZO ${currentYear}`, `ABRIL ${currentYear}`,
    `MAYO ${currentYear}`, `JUNIO ${currentYear}`, `JULIO ${currentYear}`, `AGOSTO ${currentYear}`,
    `SEPTIEMBRE ${currentYear}`, `OCTUBRE ${currentYear}`, `NOVIEMBRE ${currentYear}`, `DICIEMBRE ${currentYear}`
  ];

    months.forEach(month => {
      const filteredData = this.TopTenCadXImpOpDivXMes.filter(item => item.mes === month);

      // Convert 'total' to number and sort by descending order
      filteredData.sort((a, b) => parseFloat(b.total) - parseFloat(a.total));

      this.groupedDataCad[month] = {
        data: filteredData,
        visible: false
      };
    });
    this.currentMonth = this.getCurrentMonthCad();
    if (this.currentMonth && this.groupedDataCad[this.currentMonth]) {
      this.groupedDataCad[this.currentMonth].visible = true;
    }
  }

  getCurrentMonthCad(): string {
    const currentDate = new Date();
    const monthNames = [
        "ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO",
        "JULIO", "AGOSTO", "SEPTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE"
    ];
    const month = monthNames[currentDate.getMonth()];
    const year = currentDate.getFullYear();
    return `${month} ${year}`;
}

  toggleVisibilityCad(month: string) {
    this.groupedDataCad[month].visible = !this.groupedDataCad[month].visible;
  }

  getKeysCad(obj: { [key: string]: { data: any[], visible: boolean } }) {
    return Object.keys(obj);
  }

  esmovil(wid) {
    if(wid < 640) {
      this.mobile = true;
    } else {
    this.mobile = false;
    }
  }
  // REVISAR_ELIMINAR: changeLg() no se llama desde el template HTML
  // changeLg(){
  //   let LgSel = (document.getElementById('selLg') as HTMLInputElement).value;
  //   if(LgSel == 'ES'){
  //     this.delinquencyCols = this.delinquencyColsES;
  //     this.titulo = this.tituloES;
  //   }else if(LgSel == 'EN'){
  //     this.delinquencyCols = this.delinquencyColsEN;
  //     this.titulo = this.tituloEN;
  //   }
  // }

  change(){
    let customerSel = (document.getElementById('selCustomer') as HTMLInputElement).value;
    if(customerSel == ''){
      this.delinquencyResume = this.delinquencyResumeOrigin;
      return;
    }
    this.delinquencyResume = this.delinquencyResumeOrigin.filter(d => d.customer == customerSel);
  }

  facturas_no_descontadas() {
    this.fileName = 'FacturasNoDescontadas.xlsx';
    /* table id is passed over here */
    const element = document.getElementById('facturasnodescontadas');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    /* save to file */
    XLSX.writeFile(wb, this.fileName);
 }

 facturas_descontadas() {
  this.fileName = 'FacturasDescontadas.xlsx';
  /* table id is passed over here */
  const element = document.getElementById('facturasdescontadas');
  const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
  /* generate workbook and add the worksheet */
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  /* save to file */
  XLSX.writeFile(wb, this.fileName);
}

descuentos_e_intereses_del_mes() {
  this.fileName = 'DescuentoseInteresesDelMes.xlsx';
  /* table id is passed over here */
  const element = document.getElementById('descuentoseinteresesdelmes');
  const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
  /* generate workbook and add the worksheet */
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  /* save to file */
  XLSX.writeFile(wb, this.fileName);
}

descuentos_totales() {
  this.fileName = 'DescuentosTotales.xlsx';
  /* table id is passed over here */
  const element = document.getElementById('descuentostotales');
  const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
  /* generate workbook and add the worksheet */
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  /* save to file */
  XLSX.writeFile(wb, this.fileName);
}

// REVISAR_ELIMINAR: siguientes_pagos() no se llama desde el template HTML
/*siguientes_pagos() {
  this.fileName = 'SiguientesPagos.xlsx';
  const element = document.getElementById('siguientespagos');
  const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  XLSX.writeFile(wb, this.fileName);
}*/

// REVISAR_ELIMINAR: porcentaje_de_descuento() no se llama desde el template HTML (solo porcentaje_de_descuento_sofom)
/*porcentaje_de_descuento() {
  this.fileName = 'PorcentajeDeDescuento.xlsx';
  const element = document.getElementById('porcentajededescuento');
  const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  XLSX.writeFile(wb, this.fileName);
}*/

// REVISAR_ELIMINAR: facturas_canceladas() no se llama desde el template HTML
/*facturas_canceladas() {
  this.fileName = 'FacturasCanceladas.xlsx';
  const element = document.getElementById('facturascanceladas');
  const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  XLSX.writeFile(wb, this.fileName);
}*/

// REVISAR_ELIMINAR: facturas_descontadas_vs_no_descontadas() no se llama desde el template HTML
/*facturas_descontadas_vs_no_descontadas() {
  this.fileName = 'FacturasDescontadasVsNoDescontadas.xlsx';
  const element = document.getElementById('facturasdescontadasvsnodescontadas');
  const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  XLSX.writeFile(wb, this.fileName);
}*/

porcentaje_de_descuento_sofom() {
  this.fileName = 'PorcentajeDeDescuento.xlsx';
  /* table id is passed over here */
  const element = document.getElementById('porcentajededescuentosofom');
  const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
  /* generate workbook and add the worksheet */
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  /* save to file */
  XLSX.writeFile(wb, this.fileName);
}

afiliados() {
  this.fileName = 'Afiliados.xlsx';
  /* table id is passed over here */
  const element = document.getElementById('afiliados');
  const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
  /* generate workbook and add the worksheet */
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  /* save to file */
  XLSX.writeFile(wb, this.fileName);
}

//funcion para convertir y tratar los datos de las tablas top ten
exportToExcel(subHed: string) {
  /* seleccionamos la data dependiendo de la tabla que vayamos a sacar el excel*/
  let tedata: { [x: string]: { data: any[]; visible: boolean; } | { data: any[]; visible: boolean; }; }
  if (subHed.toLowerCase() == 'proveedor') {
    tedata = this.groupedData;
  } else if (subHed.toLowerCase() == 'cadena' ) {
    tedata = this.groupedDataCad;
  } else {
    return;
  }
  /*se obtiene el año en curso para asignarlo a los meses garantizando que cuando se cambie de año no tener que modificar esto */
  const currentYear = new Date().getFullYear();
  const months = [
    `ENERO ${currentYear}`, `FEBRERO ${currentYear}`, `MARZO ${currentYear}`, `ABRIL ${currentYear}`,
    `MAYO ${currentYear}`, `JUNIO ${currentYear}`, `JULIO ${currentYear}`, `AGOSTO ${currentYear}`,
    `SEPTIEMBRE ${currentYear}`, `OCTUBRE ${currentYear}`, `NOVIEMBRE ${currentYear}`, `DICIEMBRE ${currentYear}`
  ];

  const worksheetData = [];
  const headers = [];
  const subHeaders = [];

  // se agregan los encabezados
  for (const month of months) {
    headers.push(month);
    headers.push(''); // se agrega un encabezado vacio para poder hacer merge
    subHeaders.push(subHed);
    subHeaders.push('Total');
  }
  worksheetData.push(headers);
  worksheetData.push(subHeaders);

  // se calcula el maximo de filas
  let maxRows = 0;
  for (const month of months) {
    const monthDataLength = tedata[month].data.length || 1;
    if (monthDataLength > maxRows) {
      maxRows = monthDataLength;
    }
  }

  // se agregan las filas con el if para dependiendo de que se selecciono agregar unas u otras
  for (let rowIndex = 0; rowIndex < maxRows; rowIndex++) {
    const row = [];
    for (const month of months) {
      const monthData = tedata[month].data;
      if (monthData.length > rowIndex) {
        if (subHed.toLowerCase() == 'proveedor') {
          row.push(`${monthData[rowIndex].proveedor}`);
          row.push(`${monthData[rowIndex].total}`);
        } else if (subHed.toLowerCase() == 'cadena' ) {
          row.push(`${monthData[rowIndex].cadena}`);
        row.push(`${monthData[rowIndex].total}`);
        }
        
      } else {
        row.push('');
        row.push('');
      }
    }
    worksheetData.push(row);
  }

  // creamos la hoja
  const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(worksheetData);

  // se hace el merge de las celdas para los encabezados
  const merges = [];
  for (let i = 0; i < months.length; i++) {
    merges.push({
      s: { r: 0, c: i * 2 },
      e: { r: 0, c: i * 2 + 1 }
    });
  }
  worksheet['!merges'] = merges;

 // aqui definimos los estilos para los encabezados (en proceso, aun no se muestran como quiero)
 const boldCenterStyle = { alignment: { horizontal: 'center' }, font: { bold: true } };

 // se aplican los estilos a los encabezados y sub encabezados
 for (let c = 0; c < headers.length; c++) {
   const headerCell = XLSX.utils.encode_cell({ r: 0, c });
   const subHeaderCell = XLSX.utils.encode_cell({ r: 1, c });
   worksheet[headerCell].s = boldCenterStyle;
   worksheet[subHeaderCell].s = boldCenterStyle;
 }


  // se ajusta el ancho de las columnas
  const colWidths = [];
  for (let i = 0; i < months.length; i++) {
    colWidths.push({ wpx: 200 });
    colWidths.push({ wpx: 200 });
  }
  worksheet['!cols'] = colWidths;

  const workbook: XLSX.WorkBook = { Sheets: { 'Data': worksheet }, SheetNames: ['Data'] };

  // por ultimo escribimos el archivo
  XLSX.writeFile(workbook, 'Data.xlsx');
}

genxls(id: string) {
  this.fileName = id + '.xlsx';

  // obtener instancias de los pipes
  const monthYearFormatPipe = this.injector.get(MonthYearFormatPipe);

  // obtener los datos de la tabla
  const table = document.getElementById(id) as HTMLTableElement;
  const dataArray = [];

  // iteramos sobre las filas de la tabla
  for (let i = 0; i < table.rows.length; i++) {
    const row = table.rows[i];
    const rowData = [];

    // iteramos sobre las celdas de la fila
    for (let j = 0; j < row.cells.length; j++) {
      const cell = row.cells[j];
      let cellValue = cell.innerText.trim();

      // aplicamos pipes a las celdas correspondientes
      if (i !== 0 && j === 0) { 
        cellValue = monthYearFormatPipe.transform(cellValue);
      }

      rowData.push(cellValue);
    }

    dataArray.push(rowData);
  }

  // formateamos las cantidades como números
  for (let r = 1; r < dataArray.length; r++) { // empezar desde 1 para omitir la fila de encabezados
    const row = dataArray[r];
    for (let c = 1; c < row.length; c++) { // empezar desde 1 para omitir la primera columna
      const cellValue = row[c];
      const numericValue = parseFloat(cellValue.replace(/,/g, '')); // convertimos string a numero, eliminando comas
      if (!isNaN(numericValue)) {
        row[c] = numericValue; // reemplazamos el valor de la celda con el valor numérico
      }
    }
  }

  // creamos la hoja 
  const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(dataArray);
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

  // exportamos la hoja a exccel
  XLSX.writeFile(wb, this.fileName);
}

toggleElements(ele: string) {
  let animationClassKey: string;
  let stateKey: string;

  switch (ele) {
    case 'ro1':
      stateKey = 'ro1';
      animationClassKey = 'animationClassRo1';
      break;
    case 'ro2':
      stateKey = 'ro2';
      animationClassKey = 'animationClass';
      break;
    case 'ro3':
      stateKey = 'ro3';
      animationClassKey = 'animationClassRo3';
      break;
    case 'ro4':
      stateKey = 'ro4';
      animationClassKey = 'animationClassRo4';
      break;
    case 'ro5':
      stateKey = 'ro5';
      animationClassKey = 'animationClassRo5';
      break;
    default:
      return;
  }

  if (this[stateKey]) {
    this[animationClassKey] = 'slide-up';
    setTimeout(() => {
      this[stateKey] = !this[stateKey];
      this[animationClassKey] = '';
    }, 500);
  } else {
    this[stateKey] = !this[stateKey];
    this[animationClassKey] = 'slide-down';
  }
}

//para expandir la tabla delinquenci
cch() {
  this.deltab = !this.deltab;
}
// REVISAR_ELIMINAR: cc() no se llama desde el template HTML (solo se usa cch())
/*cc() {
  if (this.deltab) {
    var x = document.getElementById("siguientespagospp");
    var a = document.getElementsByName("1-30");
    var b = document.getElementsByName("31-60");
    var c = document.getElementsByName("46-60");
    var d = document.getElementsByName("61-90");
    var e = document.getElementsByName("mas90");
    var f = document.getElementsByName("oldest");
    var ths = x.getElementsByTagName("th");
    var thd = x.getElementsByTagName("td");
    ths[1].style.display = 'none'
    ths[2].style.display = 'none'
    ths[3].style.display = 'none'
    ths[4].style.display = 'none'
    ths[5].style.display = 'none'
    ths[6].style.display = 'none'
    a.forEach((el) => {
      el.style.display = 'none'
    })
    b.forEach((el) => {
      el.style.display = 'none'
    })
    c.forEach((el) => {
      el.style.display = 'none'
    })
    d.forEach((el) => {
      el.style.display = 'none'
    })
    e.forEach((el) => {
      el.style.display = 'none'
    })
    f.forEach((el) => {
      el.style.display = 'none'
    })
    this.deltab = false;
  } else {
    var x = document.getElementById("siguientespagospp");
    var a = document.getElementsByName("1-30");
    var b = document.getElementsByName("31-60");
    var c = document.getElementsByName("46-60");
    var d = document.getElementsByName("61-90");
    var e = document.getElementsByName("mas90");
    var f = document.getElementsByName("oldest");
    var ths = x.getElementsByTagName("th");
    var thd = x.getElementsByTagName("td");
    ths[1].style.display = 'inline'
    ths[2].style.display = 'inline'
    ths[3].style.display = 'inline'
    ths[4].style.display = 'inline'
    ths[5].style.display = 'inline'
    ths[6].style.display = 'inline'
    a.forEach((el) => {
      el.style.display = 'block'
    })
    b.forEach((el) => {
      el.style.display = 'block'
    })
    c.forEach((el) => {
      el.style.display = 'block'
    })
    d.forEach((el) => {
      el.style.display = 'block'
    })
    e.forEach((el) => {
      el.style.display = 'block'
    })
    f.forEach((el) => {
      el.style.display = 'block'
    })
    this.deltab = true;
  }
  

}*/

//Paginacion tabla bancoppel//
pgone() {
  this.currentPage = 1;
}

/*get filteredDataq(): any[] {
  return this.SolFonHisEsDifsol.filter(item =>
    (item.folio_factura && item.folio_factura.toLowerCase().includes(this.searchTerm.toLowerCase())) || '' ||
    (item.folio_solicitud && item.folio_solicitud.toLowerCase().includes(this.searchTerm.toLowerCase())) || '' ||
    (item.fecha && item.fecha.toLowerCase().includes(this.searchTerm.toLowerCase())) || '' ||
    (item.estatus && item.estatus.toLowerCase().includes(this.searchTerm.toLowerCase())) || '' ||
    (item.monto_operado && item.monto_operado.toLowerCase().includes(this.searchTerm.toLowerCase())) || ''
  );
}*/

get filteredDataq(): any[] {
  const filtered = this.SolFonHisEsDifsol.filter(item => //return
    (!this.searchTerms.folio_solicitud_fondeo || (item.folio_solicitud_fondeo && item.folio_solicitud_fondeo.toLowerCase().includes(this.searchTerms.folio_solicitud_fondeo.toLowerCase()))) &&
    (!this.searchTerms.cadena || (item.cadena && item.cadena.toLowerCase().includes(this.searchTerms.cadena.toLowerCase()))) &&
    (!this.searchTerms.fecha_solicitud || (item.fecha_solicitud && item.fecha_solicitud.toLowerCase().includes(this.searchTerms.fecha_solicitud.toLowerCase()))) &&
    (!this.searchTerms.moneda || (item.moneda && item.moneda.toLowerCase().includes(this.searchTerms.moneda.toLowerCase()))) &&
    (!this.searchTerms.total || (item.total && item.total.toString().toLowerCase().includes(this.searchTerms.total.toLowerCase()))) &&
    (!this.searchTerms.total_operado || (item.total_operado && item.total_operado.toString().toLowerCase().includes(this.searchTerms.total_operado.toLowerCase()))) &&
    (!this.searchTerms.intereses || (item.intereses && item.intereses.toString().toLowerCase().includes(this.searchTerms.intereses.toLowerCase()))) &&
    (!this.searchTerms.monto_neto || (item.monto_neto && item.monto_neto.toString().toLowerCase().includes(this.searchTerms.monto_neto.toLowerCase())))
  );
  return filtered.sort((a, b) => this.compare(a, b, this.sortColumn, this.sortDirection));
}

get dataToShow(): any[] {
  const startIndex = (this.currentPage - 1) * this.itemsPerPage;
  return this.filteredDataq.slice(startIndex, startIndex + this.itemsPerPage);
}

get totalPages(): number {
  return Math.ceil(this.filteredDataq.length / this.itemsPerPage);
}

get pages(): number[] {
  const totalPages = this.totalPages;

  if (totalPages <= this.maxVisiblePages) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  const pages = [];
  const halfRange = Math.floor(this.maxVisiblePages / 2);

  let startPage = Math.max(1, this.currentPage - halfRange);
  let endPage = Math.min(totalPages, startPage + this.maxVisiblePages - 1);

  if (endPage === totalPages) {
    startPage = totalPages - this.maxVisiblePages + 1;
  }
  if (startPage === 1) {
    endPage = this.maxVisiblePages;
  }

  for (let i = startPage; i <= endPage; i++) {
    pages.push(i);
  }

  return pages;
}

// Métodos de navegación
goToPage(page: number): void {
  if (page >= 1 && page <= this.totalPages) {
    this.currentPage = page;
  }
}

previousPage(): void {
  if (this.currentPage > 1) {
    this.currentPage--;
  }
}

nextPage(): void {
  if (this.currentPage < this.totalPages) {
    this.currentPage++;
  }
}

goToEllipsisPage(position: 'first' | 'last'): void {
  if (position === 'first') {
    this.currentPage = 1;
  } else if (position === 'last') {
    this.currentPage = this.totalPages;
  }
}

exportExcelFil(tab: string) {
  let fullData: any[]
  if (tab === 'NoSol') {
    fullData = this.filteredDataq;
  } else if (tab === 'SiSol') {
    fullData = this.SolFonHisEssol;
  }
  const readOpts = {
      cellText: false, 
      cellDates: true,
  };
 // Generar los datos personalizados para exportación
 const dataToExport = fullData.map(item => ({
  'Folio': item.folio_solicitud_fondeo || '',
  'Empresa': item.cadena || '',
  'Fecha': this.formatFecha(item.fecha_solicitud) || '',
  'Moneda': item.moneda || '',
  'Total': this.removeCommas(item.total) || '',
  'Total operado': this.removeCommas(item.total_operado) || '',
  'Intereses': this.removeCommas(item.intereses) || '',
  'Monto neto': this.removeCommas(item.monto_neto) || ''
}));
  const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport, readOpts);
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  XLSX.writeFile(wb, 'solicitudes.xlsx', readOpts);
}

 formatFecha(fecha: { split: (arg0: string) => [any, any, any]; }) {
  if (!fecha) return '';
  const [year, month, day] = fecha.split('-');
  return `${day}/${month}/${year}`;
}

removeCommas(monto: { toString: () => string; }) {
  if (!monto) return '';
  return monto.toString().replace(/,/g, ''); // Elimina todas las comas
}

reporfac(idsf: any) {
  this.fundersService.getfundingrequest(idsf).subscribe(resp => {
    this.selectedIdsf = idsf;
    this.datosdetalles = resp['data'].relations.funding_request_invoices;
    this.showmodalds = true;
  })
}

hideds() {
  this.showmodalds = false;
}

exportExcelcxc() {
  this.fileName = 'Data.xlsx';
  /* table id is passed over here */
  const element = document.getElementById('CXC');
  const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
  /* generate workbook and add the worksheet */
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  /* save to file */
  XLSX.writeFile(wb, this.fileName);
}

sortData(column: string): void {
  // Cambia la dirección de ordenación si se selecciona la misma columna, de lo contrario reinicia a ascendente
  if (this.sortColumn === column) {
    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
  } else {
    this.sortColumn = column;
    this.sortDirection = 'asc';
  }
}

private compare(a: any, b: any, column: string, direction: 'asc' | 'desc'): number {
  if (!column) return 0;

  const valueA = a[column];
  const valueB = b[column];

  let comparison = 0;
  if (valueA > valueB) {
    comparison = 1;
  } else if (valueA < valueB) {
    comparison = -1;
  }

  return direction === 'asc' ? comparison : -comparison;
}
/////////////////////////////

exportexcelN() {
    if (this.selectedIdsf) {
      this.fundersService.getfundersrequestinvoicesdetails(this.selectedIdsf).subscribe(response => {
        let datos = response;
        this.generateExcel(datos);
      });
    }
  }

  generateExcel(data: any[]) {
    // Crear encabezados agrupados según el formato del Excel
    const headers = [
      [
        "DATOS DE LOS DOCUMENTOS", "", "", "", "", "","","","","","",
        "SOLICITUD DE FACTORAJE", "","","","","","",
        "SOLICITUD DE FONDEO", "","","","","","",
        "REBATE", "", "", "", "","",""
      ],
      [
        "Folio Letra", "Folio solicitud", "Folio Solicitud Fondeo", "Emisor", "Receptor", "Moneda", "Fecha de operación", "Fecha de cobranza","Fecha de vencimiento","Fecha de carga","Estatus",
        "Tasa interbancaria",	"Sobretasa",	"Tasa total",	"Días descuento",	"Total operado",	"Intereses",	"Monto neto",
        "Tasa interbancaria",	"Sobretasa",	"Tasa total",	"Días descuento",	"Total operado",	"Intereses",	"Monto neto",
        "Total operado",	"Días descuento",	"Fee Factor",	"Tasa rebate",	"Rebate total",	"Rebate cadena",	"Rebate fondeador"
      ]
    ];

    // Transformar datos en formato para incluir en el Excel
    const rows = data.map(item => [
      item.folio_letra,
      item.folio_solicitud,
      item.folio_solicitud_fondeo,
      item.emisor,
      item.receptor,
      item.moneda,
      item.fecha_operacion,
      item.fecha_cobranza,
      item.fecha_vencimiento,
      item.fecha_carga,
      item.estatus,
      item.tasa_interbancaria,
      item.sobre_tasa,
      item.tasa_total,
      item.dias_descuento,
      item.total_operado,
      item.intereses,
      item.monto_neto,
      item.fr_tasa_interbancaria,
      item.fr_sobre_tasa,
      item.fr_tasa_total,
      item.fr_dias_descuento,
      item.fr_total_operado,
      item.fr_intereses,
      item.fr_monto_neto,
      item.fri_rebate_total_operado,
      item.fri_rebate_dias_descuento,
      item.fee_factor,
      item.tasa_rebate,
      item.rebate_total,
      item.rebate_cadena,
      item.rebate_fondeador
    ]);

    // Combinar encabezados y datos
    const worksheetData = headers.concat(rows);

    // Crear la hoja de cálculo
    const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(worksheetData);

    // Ajustar los estilos de los encabezados agrupados
    worksheet['!merges'] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: 10 } }, // "Datos de las Letras de Cambio"
      { s: { r: 0, c: 11 }, e: { r: 0, c: 17 } }, // "Solicitud de Factoraje"
      { s: { r: 0, c: 18 }, e: { r: 0, c: 24 } }, // "Solicitud de Fondeo"
      { s: { r: 0, c: 25 }, e: { r: 0, c: 31 } }, // "Rebate"
    ];

    // Crear el libro de Excel
    const workbook: XLSX.WorkBook = {
      SheetNames: ['Detalle'],
      Sheets: { Detalle: worksheet }
    };

    // Exportar el archivo
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    // Guardar el archivo usando FileSaver
    const dataBlob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    //saveAs(dataBlob, 'Detalle_Operaciones.xlsx');
    XLSX.writeFile(workbook, 'Detalle_Operaciones.xlsx');
  }

  //REPORTE FACTURAS COMPANY///////////////////////////////////////////////////////////////////////////////////////////////////////////////
  pgoneCo() {
    this.currentPageCo = 1;
  }

  get filteredDataqCo(): any[] {
    const filtered = this.facturas.filter(item => {
      // Saltar filtrado si está en modo edición
      if (this.isEditing) {
        return true;
      }
  
      // Filtros existentes
      return (
        (!this.searchTermsCo.id_factura || (item.id_factura && item.id_factura.toString().toLowerCase().includes(this.searchTermsCo.id_factura.toLowerCase()))) &&
        (!this.searchTermsCo.folio_factura || (item.folio_factura && item.folio_factura.toLowerCase().includes(this.searchTermsCo.folio_factura.toLowerCase()))) &&
      (!this.searchTermsCo.folio_solicitud || (this.searchTermsCo.folio_solicitud === 'null' && item.folio_solicitud === null) || (item.folio_solicitud && item.folio_solicitud.toLowerCase().includes(this.searchTermsCo.folio_solicitud.toLowerCase()))) &&
      (!this.searchTermsCo.folio_solicitud_fondeo || (item.folio_solicitud_fondeo && item.folio_solicitud_fondeo.toLowerCase().includes(this.searchTermsCo.folio_solicitud_fondeo.toLowerCase()))) &&
      (!this.searchTermsCo.uuid_factura_descontada || (item.uuid_factura_descontada && item.uuid_factura_descontada.toLowerCase().includes(this.searchTermsCo.uuid_factura_descontada.toLowerCase()))) &&
      (!this.searchTermsCo.emisor || (item.emisor && item.emisor.toString().toLowerCase().includes(this.searchTermsCo.emisor.toLowerCase()))) &&
      (!this.searchTermsCo.receptor || (item.receptor && item.receptor.toString().toLowerCase().includes(this.searchTermsCo.receptor.toLowerCase()))) &&
      (!this.searchTermsCo.customer_credit_name || (item.customer_credit_name && item.customer_credit_name.toString().toLowerCase().includes(this.searchTermsCo.customer_credit_name.toLowerCase()))) &&
      (!this.searchTermsCo.moneda || (item.moneda && item.moneda.toString().toLowerCase().includes(this.searchTermsCo.moneda.toLowerCase()))) &&
      (!this.searchTermsCo.fecha_operacion || (item.fecha_operacion && item.fecha_operacion.toString().toLowerCase().includes(this.searchTermsCo.fecha_operacion.toLowerCase()))) &&
      (!this.searchTermsCo.fecha_cobranza || (item.fecha_cobranza && item.fecha_cobranza.toString().toLowerCase().includes(this.searchTermsCo.fecha_cobranza.toLowerCase()))) &&
      (!this.searchTermsCo.fecha_vencimiento || (item.fecha_vencimiento && item.fecha_vencimiento.toString().toLowerCase().includes(this.searchTermsCo.fecha_vencimiento.toLowerCase()))) &&
      (!this.searchTermsCo.fecha_emision || (item.fecha_emision && item.fecha_emision.toLowerCase().includes(this.searchTermsCo.fecha_emision.toLowerCase()))) &&
      (!this.searchTermsCo.fecha_carga || (item.fecha_carga && item.fecha_carga.toLowerCase().includes(this.searchTermsCo.fecha_carga.toLowerCase()))) &&
      (!this.searchTermsCo.estatus || (item.estatus && item.estatus.toLowerCase().includes(this.searchTermsCo.estatus.toLowerCase()))) &&
      (!this.searchTermsCo.total_factura || (item.total_factura && item.total_factura.toLowerCase().includes(this.searchTermsCo.total_factura.toLowerCase()))) &&
      (!this.searchTermsCo.porcentaje_operado || (item.porcentaje_operado && item.porcentaje_operado.toString().toLowerCase().includes(this.searchTermsCo.porcentaje_operado.toLowerCase()))) &&
      (!this.searchTermsCo.monto_operado || (item.monto_operado && item.monto_operado.toString().toLowerCase().includes(this.searchTermsCo.monto_operado.toLowerCase()))) &&
      (!this.searchTermsCo.disponible || (item.disponible && item.disponible.toString().toLowerCase().includes(this.searchTermsCo.disponible.toLowerCase()))) &&
      (!this.searchTermsCo.intereses || (item.intereses && item.intereses.toString().toLowerCase().includes(this.searchTermsCo.intereses.toLowerCase()))) &&
      (!this.searchTermsCo.tasa_interbancaria || (item.tasa_interbancaria && item.tasa_interbancaria.toString().toLowerCase().includes(this.searchTermsCo.tasa_interbancaria.toLowerCase()))) &&
      (!this.searchTermsCo.sobretasa || (item.sobretasa && item.sobretasa.toString().toLowerCase().includes(this.searchTermsCo.sobretasa.toLowerCase()))) &&
      (!this.searchTermsCo.tasa_total || (item.tasa_total && item.tasa_total.toLowerCase().includes(this.searchTermsCo.tasa_total.toLowerCase()))) &&
      (!this.searchTermsCo.comision || (item.comision && item.comision.toLowerCase().includes(this.searchTermsCo.comision.toLowerCase()))) &&
      (!this.searchTermsCo.costo_financiero || (item.costo_financiero && item.costo_financiero.toLowerCase().includes(this.searchTermsCo.costo_financiero.toLowerCase()))) &&
      (!this.searchTermsCo.dias_descuento || (item.dias_descuento && item.dias_descuento.toLowerCase().includes(this.searchTermsCo.dias_descuento.toLowerCase()))) &&
      (!this.searchTermsCo.monto_neto || (item.monto_neto && item.monto_neto.toString().toLowerCase().includes(this.searchTermsCo.monto_neto.toLowerCase()))) &&
      (!this.searchTermsCo.tasa_comision || (item.tasa_comision && item.tasa_comision.toString().toLowerCase().includes(this.searchTermsCo.tasa_comision.toLowerCase()))) &&
      (!this.searchTermsCo.dia_pago_cadena || (item.dia_pago_cadena && item.dia_pago_cadena.toString().toLowerCase().includes(this.searchTermsCo.dia_pago_cadena.toLowerCase()))) &&
      (!this.searchTermsCo.monto_pago || (item.monto_pago && item.monto_pago.toString().toLowerCase().includes(this.searchTermsCo.monto_pago.toLowerCase()))) &&
      (!this.searchTermsCo.dias_al_vencimiento || (item.dias_al_vencimiento && item.dias_al_vencimiento.toString().toLowerCase().includes(this.searchTermsCo.dias_al_vencimiento.toLowerCase()))) &&
      (!this.searchTermsCo.dias_para_vencimiento || (item.dias_para_vencimiento && item.dias_para_vencimiento.toString().toLowerCase().includes(this.searchTermsCo.dias_para_vencimiento.toLowerCase()))) &&
        // Resto de los filtros
        true
      );
    });
  
    return filtered.sort((a, b) => this.compareCo(a, b, this.sortColumnCo, this.sortDirectionCo));
  }
  
  // REVISAR_ELIMINAR: filteredDataqqCo (con doble q) nunca se usa en el template ni en el TS — es duplicado de filteredDataqCo
  /*get filteredDataqqCo(): any[] {
    
    const filtered = this.facturas.filter(item => 
      
      (!this.searchTermsCo.id_factura || (item.id_factura && item.id_factura.toString().toLowerCase().includes(this.searchTermsCo.id_factura.toLowerCase()))) &&
      (!this.searchTermsCo.folio_factura || (item.folio_factura && item.folio_factura.toLowerCase().includes(this.searchTermsCo.folio_factura.toLowerCase()))) &&
      (!this.searchTermsCo.folio_solicitud || (this.searchTermsCo.folio_solicitud === 'null' && item.folio_solicitud === null) || (item.folio_solicitud && item.folio_solicitud.toLowerCase().includes(this.searchTermsCo.folio_solicitud.toLowerCase()))) &&
      (!this.searchTermsCo.folio_solicitud_fondeo || (item.folio_solicitud_fondeo && item.folio_solicitud_fondeo.toLowerCase().includes(this.searchTermsCo.folio_solicitud_fondeo.toLowerCase()))) &&
      (!this.searchTermsCo.uuid_factura_descontada || (item.uuid_factura_descontada && item.uuid_factura_descontada.toLowerCase().includes(this.searchTermsCo.uuid_factura_descontada.toLowerCase()))) &&
      (!this.searchTermsCo.emisor || (item.emisor && item.emisor.toString().toLowerCase().includes(this.searchTermsCo.emisor.toLowerCase()))) &&
      (!this.searchTermsCo.receptor || (item.receptor && item.receptor.toString().toLowerCase().includes(this.searchTermsCo.receptor.toLowerCase()))) &&
      (!this.searchTermsCo.customer_credit_name || (item.customer_credit_name && item.customer_credit_name.toString().toLowerCase().includes(this.searchTermsCo.customer_credit_name.toLowerCase()))) &&
      (!this.searchTermsCo.moneda || (item.moneda && item.moneda.toString().toLowerCase().includes(this.searchTermsCo.moneda.toLowerCase()))) &&
      (!this.searchTermsCo.fecha_operacion || (item.fecha_operacion && item.fecha_operacion.toString().toLowerCase().includes(this.searchTermsCo.fecha_operacion.toLowerCase()))) &&
      (!this.searchTermsCo.fecha_cobranza || (item.fecha_cobranza && item.fecha_cobranza.toString().toLowerCase().includes(this.searchTermsCo.fecha_cobranza.toLowerCase()))) &&
      (!this.searchTermsCo.fecha_vencimiento || (item.fecha_vencimiento && item.fecha_vencimiento.toString().toLowerCase().includes(this.searchTermsCo.fecha_vencimiento.toLowerCase()))) &&
      (!this.searchTermsCo.fecha_emision || (item.fecha_emision && item.fecha_emision.toLowerCase().includes(this.searchTermsCo.fecha_emision.toLowerCase()))) &&
      (!this.searchTermsCo.fecha_carga || (item.fecha_carga && item.fecha_carga.toLowerCase().includes(this.searchTermsCo.fecha_carga.toLowerCase()))) &&
      (!this.searchTermsCo.estatus || (item.estatus && item.estatus.toLowerCase().includes(this.searchTermsCo.estatus.toLowerCase()))) &&
      (!this.searchTermsCo.total_factura || (item.total_factura && item.total_factura.toLowerCase().includes(this.searchTermsCo.total_factura.toLowerCase()))) &&
      (!this.searchTermsCo.porcentaje_operado || (item.porcentaje_operado && item.porcentaje_operado.toString().toLowerCase().includes(this.searchTermsCo.porcentaje_operado.toLowerCase()))) &&
      (!this.searchTermsCo.monto_operado || (item.monto_operado && item.monto_operado.toString().toLowerCase().includes(this.searchTermsCo.monto_operado.toLowerCase()))) &&
      (!this.searchTermsCo.disponible || (item.disponible && item.disponible.toString().toLowerCase().includes(this.searchTermsCo.disponible.toLowerCase()))) &&
      (!this.searchTermsCo.intereses || (item.intereses && item.intereses.toString().toLowerCase().includes(this.searchTermsCo.intereses.toLowerCase()))) &&
      (!this.searchTermsCo.tasa_interbancaria || (item.tasa_interbancaria && item.tasa_interbancaria.toString().toLowerCase().includes(this.searchTermsCo.tasa_interbancaria.toLowerCase()))) &&
      (!this.searchTermsCo.sobretasa || (item.sobretasa && item.sobretasa.toString().toLowerCase().includes(this.searchTermsCo.sobretasa.toLowerCase()))) &&
      (!this.searchTermsCo.tasa_total || (item.tasa_total && item.tasa_total.toLowerCase().includes(this.searchTermsCo.tasa_total.toLowerCase()))) &&
      (!this.searchTermsCo.comision || (item.comision && item.comision.toLowerCase().includes(this.searchTermsCo.comision.toLowerCase()))) &&
      (!this.searchTermsCo.costo_financiero || (item.costo_financiero && item.costo_financiero.toLowerCase().includes(this.searchTermsCo.costo_financiero.toLowerCase()))) &&
      (!this.searchTermsCo.dias_descuento || (item.dias_descuento && item.dias_descuento.toLowerCase().includes(this.searchTermsCo.dias_descuento.toLowerCase()))) &&
      (!this.searchTermsCo.monto_neto || (item.monto_neto && item.monto_neto.toString().toLowerCase().includes(this.searchTermsCo.monto_neto.toLowerCase()))) &&
      (!this.searchTermsCo.tasa_comision || (item.tasa_comision && item.tasa_comision.toString().toLowerCase().includes(this.searchTermsCo.tasa_comision.toLowerCase()))) &&
      (!this.searchTermsCo.dia_pago_cadena || (item.dia_pago_cadena && item.dia_pago_cadena.toString().toLowerCase().includes(this.searchTermsCo.dia_pago_cadena.toLowerCase()))) &&
      (!this.searchTermsCo.monto_pago || (item.monto_pago && item.monto_pago.toString().toLowerCase().includes(this.searchTermsCo.monto_pago.toLowerCase()))) &&
      (!this.searchTermsCo.dias_al_vencimiento || (item.dias_al_vencimiento && item.dias_al_vencimiento.toString().toLowerCase().includes(this.searchTermsCo.dias_al_vencimiento.toLowerCase()))) &&
      (!this.searchTermsCo.dias_para_vencimiento || (item.dias_para_vencimiento && item.dias_para_vencimiento.toString().toLowerCase().includes(this.searchTermsCo.dias_para_vencimiento.toLowerCase())))
    );
    
    return filtered.sort((a, b) => this.compareCo(a, b, this.sortColumnCo, this.sortDirectionCo));
    
  }*/
  
  get dataToShowCo(): any[] {
      const startIndex = (this.currentPageCo - 1) * this.itemsPerPageCo;
      return this.filteredDataqCo.slice(startIndex, startIndex + this.itemsPerPageCo);
    
  }
  
  get totalPagesCo(): number {
    return Math.ceil(this.filteredDataqCo.length / this.itemsPerPageCo);
  }
  
  get pagesCo(): number[] {
    const totalPages = this.totalPagesCo;
  
    if (totalPages <= this.maxVisiblePagesCo) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }
  
    const pagesCo = [];
    const halfRange = Math.floor(this.maxVisiblePagesCo / 2);
  
    let startPage = Math.max(1, this.currentPageCo - halfRange);
    let endPage = Math.min(totalPages, startPage + this.maxVisiblePagesCo - 1);
  
    if (endPage === totalPages) {
      startPage = totalPages - this.maxVisiblePagesCo + 1;
    }
    if (startPage === 1) {
      endPage = this.maxVisiblePagesCo;
    }
  
    for (let i = startPage; i <= endPage; i++) {
      pagesCo.push(i);
    }
  
    return pagesCo;
  }
  
  // Métodos de navegación
  goToPageCo(page: number): void {
    if (page >= 1 && page <= this.totalPagesCo) {
      this.currentPageCo = page;
    }
  }
  
  previousPageCo(): void {
    if (this.currentPageCo > 1) {
      this.currentPageCo--;
    }
  }
  
  nextPageCo(): void {
    if (this.currentPageCo < this.totalPagesCo) {
      this.currentPageCo++;
    }
  }
  
  goToEllipsisPageCo(position: 'first' | 'last'): void {
    if (position === 'first') {
      this.currentPageCo = 1;
    } else if (position === 'last') {
      this.currentPageCo = this.totalPagesCo;
    }
  }
  
  exportExcelFilCo() {
    let fullData: any[];
    fullData = this.filteredDataqCo;
    const readOpts = {
      cellText: false,
      cellDates: true,
    };
  
    // Generar los datos personalizados para exportación
    const dataToExport = fullData.map(item => ({
      'ID': item.id_factura || '',
      'Folio factura': item.folio_factura || '',
      'Folio solicitud': item.folio_solicitud || '',
      'Folio Solicitud Fondeo': item.folio_solicitud_fondeo || '',
      'UUID': item.uuid_factura_descontada || '',
      'Emisor': item.emisor,//[this.proveedor]: item.emisor || '',
      'Receptor':item.receptor,//[this.cadena]: item.receptor || '',
      'Cliente': item.customer_credit_name || '',
      'Moneda': item.moneda || '',
      'Fecha de operación': this.convertToDateCo(item.fecha_operacion),
      'Fecha de cobranza': this.convertToDateCo(item.fecha_cobranza),
      'Fecha de vencimiento': this.convertToDateCo(item.fecha_vencimiento),
      'Fecha de emision': this.convertToDateCo(item.fecha_emision) || '',
      'Fecha de carga': this.convertToDateCo(item.fecha_carga) || '',
      'Estatus': item.estatus || '',
      'Total factura': this.removeCommas(item.total_factura) || '',
      'Porcentaje operado': this.removeCommas(item.porcentaje_operado) || '',
      'Total': this.removeCommas(item.monto_operado) || '',
      'Disponible': this.removeCommas(item.disponible) || '',
      'Intereses': this.removeCommas(item.intereses) || '',
      'Tasa interbancaria': this.removeCommas(item.tasa_interbancaria) || '',
      'Sobretasa': this.removeCommas(item.sobretasa) || '',
      'Tasa total': this.removeCommas(item.tasa_total) || '',
      'Comisión Total': this.removeCommas(item.comision) || '',
      'Costo financiero': this.removeCommas(item.costo_financiero) || '',
      'Días descuento': this.removeCommas(item.dias_descuento) || '',
      'Monto neto': this.removeCommas(item.monto_neto) || '',
      'Porcentaje de Comisión': item.tasa_comision || '',
      'Día de pago empresa': this.convertToDateCo(item.dia_pago_cadena) || '',
      'Monto pago': this.removeCommas(item.monto_pago) || '',
      'Días al Vencimiento': item.dias_al_vencimiento || ''
    }));
  
    // Crear el WorkSheet
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport, readOpts);
  
  
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'solicitudes.xlsx', readOpts);
  }

  convertToDateCo(fecha: string): Date | null {
    if (!fecha) return null;
    if (fecha.includes('-')) {
      const parts = fecha.split('-');
      if (parts.length === 3) {
        return new Date(+parts[0], +parts[1] - 1, +parts[2]);
      }
    }
    if (fecha.includes('/')) {
      const parts = fecha.split('/');
      if (parts.length === 3) {
        return new Date(+parts[0], +parts[1] - 1, +parts[2]);
      }
    }
    return null;
  }
  
  

  // REVISAR_ELIMINAR: removeCommasCo() nunca se llama desde el template ni desde otros métodos
  // removeCommasCo(monto: { toString: () => string; }): number | null {
  //   if (!monto) return null; // Retorna null si no hay monto
  //   const montoSinComas = monto.toString().replace(/,/g, ''); // Elimina todas las comas
  //   return parseFloat(montoSinComas); // Convierte a número
  // }
  
  sortDataCo(column: string): void {
    if (this.sortColumnCo === column) {
      this.sortDirectionCo = this.sortDirectionCo === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumnCo = column;
      this.sortDirectionCo = 'asc';
    }
  
  }
  
  private compareCo(a: any, b: any, column: string, direction: 'asc' | 'desc'): number {
    if (!column) return 0;

    let valueA = a[column];
    let valueB = b[column];
  
    // Lógica personalizada para la columna de íconos
    if (column === 'statusIcon') {
      valueA = a.status === 'ESPERA FIRMA DIGITAL' ? 0 : 1; // Prioridad para mdi-close-circle
      valueB = b.status === 'ESPERA FIRMA DIGITAL' ? 0 : 1;
    }
  
    let comparison = 0;
    if (valueA > valueB) {
      comparison = 1;
    } else if (valueA < valueB) {
      comparison = -1;
    }
  
    return direction === 'asc' ? comparison : -comparison;
  }

descargarArchivoCo(data: string, tipo: 'pdf' | 'xml'): void {
  if (tipo === 'pdf' || (tipo === 'xml' && data.startsWith('http'))) {
    // Descargar desde una URL
    const link = document.createElement('a');
    link.href = data;
    link.target = '_blank';
    link.download = `archivo.${tipo}`;
    link.click();
  } else if (tipo === 'xml') {
    // Descargar texto como archivo
    const blob = new Blob([data], { type: 'application/xml' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'archivo.xml';
    link.click();
  }
}

  toggleTable(): void {
    this.isExpanded = !this.isExpanded;
  }

  ////////////////////////////

  // FUNDER DASHBOARD - START
  // Filtrado y paginación - Líneas de Crédito
  pgoneLC() {
    this.currentPageLC = 1;
  }

  get filteredLineasCredito(): any[] {
    return this.lineasCredito.filter(item =>
      (!this.searchTermsLC.company_name || (item.company_name && item.company_name.toLowerCase().includes(this.searchTermsLC.company_name.toLowerCase()))) &&
      (!this.searchTermsLC.company_rfc || (item.company_rfc && item.company_rfc.toLowerCase().includes(this.searchTermsLC.company_rfc.toLowerCase()))) &&
      (!this.searchTermsLC.credit_limit || (item.credit_limit && item.credit_limit.toString().includes(this.searchTermsLC.credit_limit))) &&
      (!this.searchTermsLC.credit_available || (item.credit_available && item.credit_available.toString().includes(this.searchTermsLC.credit_available))) &&
      (!this.searchTermsLC.tiie_rate || (item.tiie_rate && item.tiie_rate.toString().includes(this.searchTermsLC.tiie_rate)))
    );
  }

  get dataToShowLC(): any[] {
    const startIndex = (this.currentPageLC - 1) * this.itemsPerPageLC;
    return this.filteredLineasCredito.slice(startIndex, startIndex + this.itemsPerPageLC);
  }

  get totalPagesLC(): number {
    return Math.ceil(this.filteredLineasCredito.length / this.itemsPerPageLC);
  }

  get pagesLC(): number[] {
    const totalPages = this.totalPagesLC;
    if (totalPages <= this.maxVisiblePagesLC) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }
    const pages = [];
    const halfRange = Math.floor(this.maxVisiblePagesLC / 2);
    let startPage = Math.max(1, this.currentPageLC - halfRange);
    let endPage = Math.min(totalPages, startPage + this.maxVisiblePagesLC - 1);
    if (endPage === totalPages) { startPage = totalPages - this.maxVisiblePagesLC + 1; }
    if (startPage === 1) { endPage = this.maxVisiblePagesLC; }
    for (let i = startPage; i <= endPage; i++) { pages.push(i); }
    return pages;
  }

  goToPageLC(page: number): void {
    if (page >= 1 && page <= this.totalPagesLC) { this.currentPageLC = page; }
  }
  previousPageLC(): void {
    if (this.currentPageLC > 1) { this.currentPageLC--; }
  }
  nextPageLC(): void {
    if (this.currentPageLC < this.totalPagesLC) { this.currentPageLC++; }
  }
  goToEllipsisPageLC(position: 'first' | 'last'): void {
    if (position === 'first') { this.currentPageLC = 1; } else { this.currentPageLC = this.totalPagesLC; }
  }

  // Filtrado y paginación - Facturas Fondeador
  pgoneFF() {
    this.currentPageFF = 1;
  }

  get filteredFacturasFondeador(): any[] {
    return this.facturasfondeador.filter(item =>
      (!this.searchTermsFF.funding_request_folio || (item.funding_request_folio && item.funding_request_folio.toLowerCase().includes(this.searchTermsFF.funding_request_folio.toLowerCase()))) &&
      (!this.searchTermsFF.funding_request_status || (item.funding_request_status && item.funding_request_status.toLowerCase().includes(this.searchTermsFF.funding_request_status.toLowerCase()))) &&
      (!this.searchTermsFF.invoice_folio || (item.invoice_folio && item.invoice_folio.toLowerCase().includes(this.searchTermsFF.invoice_folio.toLowerCase()))) &&
      (!this.searchTermsFF.issuer_name || (item.issuer_name && item.issuer_name.toLowerCase().includes(this.searchTermsFF.issuer_name.toLowerCase()))) &&
      (!this.searchTermsFF.receiver_name || (item.receiver_name && item.receiver_name.toLowerCase().includes(this.searchTermsFF.receiver_name.toLowerCase()))) &&
      (!this.searchTermsFF.total_operated || (item.total_operated && item.total_operated.toString().includes(this.searchTermsFF.total_operated))) &&
      (!this.searchTermsFF.total_interests || (item.total_interests && item.total_interests.toString().includes(this.searchTermsFF.total_interests))) &&
      (!this.searchTermsFF.total_net || (item.total_net && item.total_net.toString().includes(this.searchTermsFF.total_net))) &&
      (!this.searchTermsFF.total_commission || (item.total_commission && item.total_commission.toString().includes(this.searchTermsFF.total_commission))) &&
      (!this.searchTermsFF.operation_date || (item.operation_date && item.operation_date.toString().toLowerCase().includes(this.searchTermsFF.operation_date.toLowerCase()))) &&
      (!this.searchTermsFF.due_date || (item.due_date && item.due_date.toString().toLowerCase().includes(this.searchTermsFF.due_date.toLowerCase()))) &&
      (!this.searchTermsFF.operation_days || (item.operation_days && item.operation_days.toString().includes(this.searchTermsFF.operation_days))) &&
      (!this.searchTermsFF.tiie_rate || (item.tiie_rate && item.tiie_rate.toString().includes(this.searchTermsFF.tiie_rate))) &&
      (!this.searchTermsFF.surcharge_rate || (item.surcharge_rate && item.surcharge_rate.toString().includes(this.searchTermsFF.surcharge_rate))) &&
      (!this.searchTermsFF.total_rate || (item.total_rate && item.total_rate.toString().includes(this.searchTermsFF.total_rate)))
    );
  }

  get dataToShowFF(): any[] {
    const startIndex = (this.currentPageFF - 1) * this.itemsPerPageFF;
    return this.filteredFacturasFondeador.slice(startIndex, startIndex + this.itemsPerPageFF);
  }

  get totalPagesFF(): number {
    return Math.ceil(this.filteredFacturasFondeador.length / this.itemsPerPageFF);
  }

  get pagesFF(): number[] {
    const totalPages = this.totalPagesFF;
    if (totalPages <= this.maxVisiblePagesFF) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }
    const pages = [];
    const halfRange = Math.floor(this.maxVisiblePagesFF / 2);
    let startPage = Math.max(1, this.currentPageFF - halfRange);
    let endPage = Math.min(totalPages, startPage + this.maxVisiblePagesFF - 1);
    if (endPage === totalPages) { startPage = totalPages - this.maxVisiblePagesFF + 1; }
    if (startPage === 1) { endPage = this.maxVisiblePagesFF; }
    for (let i = startPage; i <= endPage; i++) { pages.push(i); }
    return pages;
  }

  goToPageFF(page: number): void {
    if (page >= 1 && page <= this.totalPagesFF) { this.currentPageFF = page; }
  }
  previousPageFF(): void {
    if (this.currentPageFF > 1) { this.currentPageFF--; }
  }
  nextPageFF(): void {
    if (this.currentPageFF < this.totalPagesFF) { this.currentPageFF++; }
  }
  goToEllipsisPageFF(position: 'first' | 'last'): void {
    if (position === 'first') { this.currentPageFF = 1; } else { this.currentPageFF = this.totalPagesFF; }
  }

  exportLineasCreditoFondeador() {
    this.fileName = 'LineasCredito_Fondeador.xlsx';
    const element = document.getElementById('lineascreditofondeador');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, this.fileName);
  }

  exportFacturasFondeador() {
    this.fileName = 'Facturas_Fondeador.xlsx';
    const element = document.getElementById('facturasfondeadortable');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, this.fileName);
  }
  // FUNDER DASHBOARD - END

  // FOREIGN SUPPLIERS DASHBOARD - START
  // 29/07/2026 - Reinicia la paginaci\u00f3n al primer segmento cuando cambia un filtro.
  pgoneFS() {
    this.currentPageFS = 1;
  }

  // 29/07/2026 - Convierte el valor booleano de facturas_subidas/operadas/pagadas a un string legible para el filtro.
  private boolToText(value: any): string {
    if (value === true) { return 'si'; }
    if (value === false) { return 'no'; }
    return '';
  }

  // 29/07/2026 - Formatea una fecha ISO al formato dd/mm/yyyy para b\u00fasqueda y visualizaci\u00f3n consistentes.
  formatFechaAltaFS(fecha: string): string {
    if (!fecha) { return ''; }
    const d = new Date(fecha);
    if (isNaN(d.getTime())) { return fecha; }
    const day = ('0' + d.getDate()).slice(-2);
    const month = ('0' + (d.getMonth() + 1)).slice(-2);
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  }

  // 29/07/2026 - Getter que aplica los filtros por columna y el ordenamiento sobre foreignSuppliers.
  get filteredForeignSuppliers(): any[] {
    const filtered = this.foreignSuppliers.filter(item => {
      const fechaTexto = this.formatFechaAltaFS(item.fecha_alta).toLowerCase();
      const subidasTexto = this.boolToText(item.facturas_subidas);
      const operadasTexto = this.boolToText(item.facturas_operadas);
      const pagadasTexto = this.boolToText(item.facturas_pagadas);
      return (
        (!this.searchTermsFS.nombre_cadena ||
          (item.nombre_cadena && item.nombre_cadena.toString().toLowerCase().includes(this.searchTermsFS.nombre_cadena.toLowerCase()))) &&
        (!this.searchTermsFS.nombre_proveedor ||
          (item.nombre_proveedor && item.nombre_proveedor.toString().toLowerCase().includes(this.searchTermsFS.nombre_proveedor.toLowerCase()))) &&
        (!this.searchTermsFS.fecha_alta || fechaTexto.includes(this.searchTermsFS.fecha_alta.toLowerCase())) &&
        (!this.searchTermsFS.facturas_subidas || subidasTexto.includes(this.searchTermsFS.facturas_subidas.toLowerCase())) &&
        (!this.searchTermsFS.facturas_operadas || operadasTexto.includes(this.searchTermsFS.facturas_operadas.toLowerCase())) &&
        (!this.searchTermsFS.facturas_pagadas || pagadasTexto.includes(this.searchTermsFS.facturas_pagadas.toLowerCase()))
      );
    });
    return filtered.sort((a, b) => this.compareFS(a, b, this.sortColumnFS, this.sortDirectionFS));
  }

  // 29/07/2026 - Devuelve el segmento de resultados a mostrar seg\u00fan la p\u00e1gina actual.
  get dataToShowFS(): any[] {
    const startIndex = (this.currentPageFS - 1) * this.itemsPerPageFS;
    return this.filteredForeignSuppliers.slice(startIndex, startIndex + this.itemsPerPageFS);
  }

  // 29/07/2026 - Total de p\u00e1ginas para el listado filtrado.
  get totalPagesFS(): number {
    return Math.ceil(this.filteredForeignSuppliers.length / this.itemsPerPageFS);
  }

  // 29/07/2026 - Calcula el rango visible de p\u00e1ginas alrededor de la p\u00e1gina activa.
  get pagesFS(): number[] {
    const totalPages = this.totalPagesFS;
    if (totalPages <= this.maxVisiblePagesFS) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }
    const pages = [];
    const halfRange = Math.floor(this.maxVisiblePagesFS / 2);
    let startPage = Math.max(1, this.currentPageFS - halfRange);
    let endPage = Math.min(totalPages, startPage + this.maxVisiblePagesFS - 1);
    if (endPage === totalPages) { startPage = totalPages - this.maxVisiblePagesFS + 1; }
    if (startPage === 1) { endPage = this.maxVisiblePagesFS; }
    for (let i = startPage; i <= endPage; i++) { pages.push(i); }
    return pages;
  }

  // 29/07/2026 - Navega a la p\u00e1gina indicada si est\u00e1 dentro del rango.
  goToPageFS(page: number): void {
    if (page >= 1 && page <= this.totalPagesFS) { this.currentPageFS = page; }
  }

  // 29/07/2026 - Retrocede una p\u00e1gina en la tabla de proveedores extranjeros.
  previousPageFS(): void {
    if (this.currentPageFS > 1) { this.currentPageFS--; }
  }

  // 29/07/2026 - Avanza una p\u00e1gina en la tabla de proveedores extranjeros.
  nextPageFS(): void {
    if (this.currentPageFS < this.totalPagesFS) { this.currentPageFS++; }
  }

  // 29/07/2026 - Salta al inicio o al final de la paginaci\u00f3n al hacer clic en las elipsis.
  goToEllipsisPageFS(position: 'first' | 'last'): void {
    if (position === 'first') { this.currentPageFS = 1; } else { this.currentPageFS = this.totalPagesFS; }
  }

  // 29/07/2026 - Alterna el ordenamiento asc/desc al hacer clic en el encabezado de una columna.
  sortDataFS(column: string): void {
    if (this.sortColumnFS === column) {
      this.sortDirectionFS = this.sortDirectionFS === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumnFS = column;
      this.sortDirectionFS = 'asc';
    }
  }

  // 29/07/2026 - Comparador gen\u00e9rico para el ordenamiento por columna en la tabla de proveedores extranjeros.
  private compareFS(a: any, b: any, column: string, direction: 'asc' | 'desc'): number {
    if (!column) { return 0; }
    let valueA = a[column];
    let valueB = b[column];
    if (column === 'fecha_alta') {
      valueA = a.fecha_alta ? new Date(a.fecha_alta).getTime() : 0;
      valueB = b.fecha_alta ? new Date(b.fecha_alta).getTime() : 0;
    }
    if (typeof valueA === 'boolean') { valueA = valueA ? 1 : 0; }
    if (typeof valueB === 'boolean') { valueB = valueB ? 1 : 0; }
    let comparison = 0;
    if (valueA > valueB) { comparison = 1; }
    else if (valueA < valueB) { comparison = -1; }
    return direction === 'asc' ? comparison : -comparison;
  }

  // 29/07/2026 - Exporta el listado filtrado de proveedores extranjeros a un archivo Excel.
  exportForeignSuppliers(): void {
    const readOpts = { cellText: false, cellDates: true };
    const dataToExport = this.filteredForeignSuppliers.map(item => ({
      'Empresa': item.nombre_cadena || '',
      'Proveedor extranjero': item.nombre_proveedor || '',
      'Fecha de alta': this.formatFechaAltaFS(item.fecha_alta),
      'Facturas subidas': item.facturas_subidas ? 'S\u00ed' : 'No',
      'Facturas operadas': item.facturas_operadas ? 'S\u00ed' : 'No',
      'Facturas pagadas': item.facturas_pagadas ? 'S\u00ed' : 'No'
    }));
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport, readOpts);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'ProveedoresExtranjeros.xlsx', readOpts);
  }
  // FOREIGN SUPPLIERS DASHBOARD - END

}
